<div class="d-flex container">
  <div>
    <div class="section-title pb-30" style="margin-top: 20px">
      <h2 class="title" style="color: #3e166c !important; font-weight: 700">
        Terms and Conditions
      </h2>
    </div>


    <div class="level-title">Last updated August 7th, 2023</div>

    <div class="level-1">
      Welcome to Klickit!
    </div>

    <div class="level-1">
      These terms and conditions outline the rules and regulations for the use of Klickit's Website, located at
      <a target="_blank" href="https://klickit.co/" style="cursor: pointer;">https://klickit.co/</a>.
    </div>

    <div class="level-1">
      By accessing this website, we assume accept these Terms and Conditions and you consent that we may process your
      shared data. Do not continue to use <a target="_blank" href="https://klickit.co/" style="cursor: pointer;">https://klickit.co/</a> if you do not agree to all of the Terms and Conditions stated on
      this page.
    </div>

    <div class="level-1">
      The following terminologies apply to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all
      Agreements: "Client", "You" and "Your" refers to you, the person logs on this website and compliant to the
      Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", “Klickit”, refers to our
      Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. “Website” and “Application” refer
      to the platform on which Klickit provides its services and products, “Services” refers to the services we provide
      the Client with. “information” and “data” refers to the Clients processed data by Klickit or any of its partners.
      All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our
      assistance to the Client in the most appropriate manner for the express purpose of meeting the Client’s needs in
      respect of provision of the Company’s stated services, in accordance with and subject to, prevailing law of Egypt.
      Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are
      taken as interchangeable and therefore as referring to same.
    </div>


    <div class="level-title">Services</div>

    <div class="level-1">
      Klickit is a fintech company operating in the education industry. We offer a secure fee management system for
      educational institutions and a hassle-free payment experience for parents. If you are using the application or the
      website, you agree to the terms of use in all the details mentioned and issues about any violation you make
      against the services we provide.
    </div>

    <div class="level-1">
      Please note that the application or the website can change its terms of use anytime, and if you continue to use it
      after changing these terms, it means you agree to it. It is therefore your responsibility to check the
      application's terms of use from time to time.
    </div>




    <div class="level-title">Registration </div>

    <div class="level-1">
      You may be required to register with the Application. You agree to keep Your password confidential and will be
      responsible for all use of Your account and password. We reserve the right to remove, reclaim, or change a
      username You select if We determine, in our sole discretion, that such username is inappropriate, obscene, or
      otherwise objectionable
    </div>

    <div class="level-1">
      You warrant that all the information regarding Your identity and capacity provided to US in the registration forms
      for the Application is true, accurate and complete. Additionally, You undertake to keep Your details up to date.
    </div>



    <div class="level-1">
      When registering on the Application, Users must choose a username and password that must be at least six
      characters, does not contain all or part of the user's account name, and contain at least three of the following
      four character categories: uppercase letters, lowercase letters, base 10 numbers, and symbols on the keyboard (eg
      !, @, # ). Both the username and the password are strictly confidential, personal and non-transferable.
    </div>

    <div class="level-1">
      Users undertake not to disclose the details of their account or allow access thereto to third parties. Users shall
      be solely responsible for any use of such details that may be made by third parties, including for statements made
      on the Application or any other action carried out under their username and/or password.
    </div>

    <div class="level-1">
      The Company cannot guarantee the identity of registered Users, and it will therefore not be liable for the use by
      unregistered third parties of a registered User’s identity. Users must immediately inform the Company by email on
      <a target="_blank" href="mailto: support@klickit.co" style="cursor: pointer;">support@klickit.co</a> , if their username or password is stolen, disclosed or lost.
    </div>



    <div class="level-title">Cookies</div>

    <div class="level-1">
      We employ the use of cookies. By accessing <a target="_blank" href="https://klickit.co/" style="cursor: pointer;">https://klickit.co/</a>, you agreed to use cookies in agreement with the
      Klickit's Privacy Policy.
    </div>

    <div class="level-1">
      Most interactive websites use cookies to let us retrieve the user’s details for each visit. Cookies are used by
      our website to enable the functionality of certain areas to make it easier for people visiting our website. Some
      of our affiliate/advertising partners may also use cookies.
    </div>



    <div class="level-title">License</div>

    <div class="level-1">
      Unless otherwise stated, Klickit owns the intellectual property rights for all material on <a target="_blank" href="https://klickit.co/" style="cursor: pointer;">https://klickit.co/</a>.
      All intellectual property rights are reserved. You may access this from <a target="_blank" href="https://klickit.co/" style="cursor: pointer;">https://klickit.co/</a> for your own personal
      use subjected to restrictions set in these Terms and Conditions.
    </div>

    <div class="level-1">
      You must not:
    </div>


    <div class="level-1">
      <ul>
        <li> &#x2022; Sell, or sub-license services from <a target="_blank" href="https://klickit.co/" style="cursor: pointer;">https://klickit.co/</a> </li>
      </ul>
    </div>

    <div class="level-1">
      The provisions of these terms and conditions shall be effective from the date your acceptance thereto.
    </div>

    <div class="level-1">
      No use of Klickit's logo or other intellectual property will be allowed without a written consent/approval.
    </div>



    <div class="level-title">iFrames</div>

    <div class="level-1">
      Without prior approval and written permission, you may not create frames around our Webpages that alter in any way
      the visual presentation or appearance of our website.
    </div>



    <div class="level-title">Liability</div>

    <div class="level-1">
      Subject to this, in no event there will be any liability for any of your business losses. Any liability, if so
      exists, shall not exceed the purchase price of the relevant Service and is strictly limited to losses that were
      reasonably foreseeable. Losses are foreseeable where they could be contemplated by you and us at the time our
      dealings.
    </div>
    <div class="level-1">
      Klickit will not be responsible for any loss or damages incurred by unauthorized use of your payment card on the
      checkout page or link, and Klickit is not responsible for notifying your card issuer or any law enforcement
      authority in these instances.
    </div>
    <div class="level-1">
      You must give Klickit a reasonable opportunity to remedy any matter for which it is liable before you incur any
      costs remedying the matter yourself.
    </div>
    <div class="level-1">
      It cannot be guaranteed that the website or application will be uninterrupted or error-free and Klickit cannot
      guarantee that the checkout will be uninterrupted or error-free. Klickit is entitled without notice and without
      liability to suspend the Website, application or the checkout page for repair, maintenance, improvement or other
      technical reason.
    </div>
    <div class="level-1">
      To the maximum extent permitted by applicable law, Klickit shall not be held liable, if and in so far as it cannot
      fulfil its obligations as a result of circumstances beyond its reasonable control and where it could not have
      taken appropriate steps to avoid such effects including third party telecommunication failures.
    </div>


    <div class="level-title">Your Privacy</div>

    <div class="level-1">
      Please access ( <a target="_blank" href="https://klickit.co/privacy" style="cursor: pointer;">https://klickit.co/privacy</a> ) to read our Privacy Policy
    </div>



    <div class="level-title">Reservation of Rights </div>

    <div class="level-1">
      We reserve the right to amend these terms and conditions. By continuously using to our platform, you agree to be
      bound to and follow these terms and conditions.
    </div>


    <div class="level-title">Disclaimer</div>

    <div class="level-1">
      To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions
      relating to our website and the use of this website. Nothing in this disclaimer will:
    </div>

    <div class="level-3">
      &#x2022; limit or exclude our or your liability for fraud or fraudulent misrepresentation;
    </div>

    <div class="level-3">
      &#x2022; limit any of our or your liabilities in any way that is not permitted under applicable law; or
    </div>

    <div class="level-3">
      &#x2022; exclude any of our or your liabilities that may not be excluded under applicable law.
    </div>

    <div class="level-1">
      The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are
      subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including
      liabilities arising in contract, in tort and for breach of statutory duty.
    </div>

    <div class="level-title">Complains:</div>

    <div class="level-1">
      If the you have any complaints regarding the services provided by Klickit or if you face any problems using
      Klickit.co, you must inform Klickit by sending an email at <a target="_blank" href="mailto: support@klickit.co" style="cursor: pointer;">support@klickit.co</a> and Klickit shall investigate such
      complaint and respond within a maximum duration of 15 working days, unless the complains are related to
      third-parties (affiliates, partners etc.…) in such case Klickit shall respond within a maximum duration of 30
      days. Klickit will do its best to solve your complaint as soon as possible and will try to prevent it from
      happening again. However, you have the right, within 15 working days from Klickit’s response, to reject Klick-t’s
      resolution and in such case Klickit will reinvestigate the complaint and respond within 15 working days. If
      Klickit fails to solve the complaint within the above-mentioned durations and/or if you are still not satisfied
      with Klickit’s solution, you may submit a complaint to the Egyptian competent authorities.
    </div>


    <div class="level-title">For the Parent:</div>

    <div class="level-1">
      You may pay via the payment methods specified at the checkout page. You acknowledge and agree that: (i) you will
      be charged by one of our third party payment processors ("Payment Processor"), through the payment method you have
      selected at Checkout for the chosen service and such other amounts payable under these Terms that may be due in
      connection with the Service; (ii) you will provide valid and current information about yourself; (iii) Klickit may
      use the tools, software or services of Payment Processors to process transactions on its behalf; and (iv) you may
      be charged bank or credit/debit card issuer with additional fees (such as foreign transaction fee or cross border
      fee) or surcharges imposed by your bank or credit/debit card issuer, and those are not Klickit charges or fees,
      and Klickit has no control over this nor does Klickit have any way to mitigate this, as this is purely up to the
      relationship and commercial terms between you and your bank or credit/debit card issuer, and Klickit also has no
      way of knowing in advance whether you will be charged such fees or surcharges, as each bank and credit/debit card
      issuer has its own policy, and Klickit commitment is to acquire the amount set at Checkout in your local currency.
    </div>


    <div class="level-title">For Merchants:</div>

    <div class="level-1">
      The Merchant hereby acknowledges and accepts the usage of its trade name and trademark on the application and in/on any advertising material conducted by Klickit. 
    </div>



    <br /><br /><br /><br /><br />
  </div>
</div>